export default "__VITE_ASSET__736b83d3__"